import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetTagcloudSeoUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Fetcher} deps.repository
   * @param {Object} deps.log
   */
  constructor({config, getTagcloudSeoService, log, seoDataRequestFactory}) {
    super()
    this._config = config
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._defaultPageName = 'ads-list'
    this._log = log
    this._fallbackResponse = []
    this._getTagcloudSeoService = getTagcloudSeoService
    this._seoDataRequestFactory = seoDataRequestFactory
  }

  /**
   * @param {Object} deps
   * @return {Promise<Object, Error>} returns array with a list of tagclouds
   * @property {Array} tag clouds list
   */
  @tracer({metric: 'GetTagcloudSeoUseCase#execute'})
  execute({
    bodyTypeId,
    categoryId,
    canonical,
    context,
    filteredOfferTypeId,
    fuelTypeId,
    hasAttributes = false,
    makeId,
    makes,
    modelId,
    models,
    offerTypeId,
    originUrl,
    pageName = this._defaultPageName,
    priceRangeGroup,
    provinceId,
    regionId,
    searchTerm,
    seats,
    semanticData,
    sellerTypeId,
    tag,
    transmissionTypeId,
    version,
    year
  }) {
    const seoDataRequest = this._seoDataRequestFactory({
      culture: this._culture,
      hasAttributes,
      pageName,
      params: {
        bodyTypeId,
        categoryId,
        canonical,
        context,
        filteredOfferTypeId,
        fuelTypeId,
        makeId,
        makes,
        modelId,
        models,
        offerTypeId,
        originUrl,
        priceRangeGroup,
        provinceId,
        regionId,
        searchTerm,
        seats,
        semanticData,
        sellerTypeId,
        tag,
        transmissionTypeId,
        version,
        year
      }
    })

    return this._getTagcloudSeoService.execute({seoDataRequest}).then(([error, tagcloudList]) => {
      if (error) {
        return Promise.reject(error)
      }

      const {tagclouds} = tagcloudList.toJSON()
      return tagclouds
    })
  }
}
